import Sobre from './sobre';

export default Sobre;